<template>
    <ElementLayout :parent="parent" :element="element">
        <v-radio-group class="compact" :label="element.title" v-model="element.value" :disabled="element.disabled" :hide-details="true" :single-line="false">
        <v-radio color="primary"
            v-for="option in options"
            :key="option"
            :label="option"
            :value="option"
        ></v-radio>
        </v-radio-group>
        <template slot="menu">
            <v-list-item @click="log">
                <v-list-item-title>Special Option Menu</v-list-item-title>
            </v-list-item>
        </template>    
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import ScreenHelpers from '@/screens/ScreenHelpers' 

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        options() {
           return ScreenHelpers.parseOptions(this.element.options)
        },
    },

    methods: {
        log() {
            console.log('menu clicked')
        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// OptionsControl.vue?777c1acc